import { StatsChartProps } from './stats-chart.types';

export const StatsChartPresets: Partial<StatsChartProps> = {
  itemsName: [],
  options: [],
};
